import { useCallback, useEffect, useState } from "react";

/* Starring is per physician and per device. It lives in the browser, not on
 * the server: a star is a personal bookmark, not part of the record, and
 * nothing clinical hangs off it. */

const key = (actorId: string) => `pagecom.stars.${actorId}`;

function read(actorId: string): Set<string> {
  try {
    const raw = localStorage.getItem(key(actorId));
    return new Set(raw ? (JSON.parse(raw) as string[]) : []);
  } catch {
    return new Set();
  }
}

export function useStars(actorId: string): [Set<string>, (pageId: string) => void] {
  const [stars, setStars] = useState<Set<string>>(() => read(actorId));
  useEffect(() => { setStars(read(actorId)); }, [actorId]);
  const toggle = useCallback((pageId: string) => {
    setStars((prev) => {
      const next = new Set(prev);
      if (next.has(pageId)) next.delete(pageId); else next.add(pageId);
      try { localStorage.setItem(key(actorId), JSON.stringify([...next])); } catch { /* private mode: stars just do not persist */ }
      return next;
    });
  }, [actorId]);
  return [stars, toggle];
}
